export enum PhishingAttributesEnums {
  SENDER,
  CONTENT,
  LINKS,
  ATTACHMENTS,
  QR_CODE
}
